import { useState } from "react";
import { motion } from "framer-motion";
import { Palette } from "lucide-react";

const palettes = [
  { name: "Bronze", accent: "#9D8058", bg: "rgba(157,128,88,0.08)", border: "rgba(157,128,88,0.2)" },
  { name: "Slate", accent: "#1e293b", bg: "rgba(30,41,59,0.08)", border: "rgba(30,41,59,0.2)" },
  { name: "Emerald", accent: "#059669", bg: "rgba(5,150,105,0.08)", border: "rgba(5,150,105,0.2)" },
  { name: "Rose", accent: "#e11d48", bg: "rgba(225,29,72,0.08)", border: "rgba(225,29,72,0.2)" },
];

const pages = ["Homepage", "Product", "Cart", "Checkout"];

export function DesignReviewPreview() {
  const [activeColor, setActiveColor] = useState(0);
  const p = palettes[activeColor];

  return (
    <div className="space-y-3">
      <div className="bg-card rounded-xl p-4 shadow-[0_1px_2px_rgba(10,13,20,0.03),0_0_0_1px_rgba(23,23,23,0.04)]">
        <p className="text-xs font-medium text-muted-foreground mb-3 flex items-center gap-1.5">
          <Palette className="h-3 w-3" />Design Review
        </p>
        <div className="flex gap-2">
          {pages.map((page, i) => (
            <motion.div
              key={page}
              className="flex-1 text-center"
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: i * 0.06 }}
            >
              <motion.div
                className="h-14 rounded-lg mb-1.5 flex flex-col items-center justify-center gap-1 overflow-hidden"
                animate={{
                  backgroundColor: i < 2 ? p.bg : "hsl(var(--secondary))",
                  borderColor: i < 2 ? p.border : "hsl(var(--border))",
                }}
                transition={{ duration: 0.35, ease: "easeInOut" }}
                style={{ border: "1px solid" }}
              >
                {/* Mini wireframe skeleton */}
                <motion.div
                  className="rounded-full h-1 w-1/2"
                  animate={{ backgroundColor: i < 2 ? p.accent : "hsl(var(--border))" }}
                  transition={{ duration: 0.35 }}
                  style={{ opacity: 0.4 }}
                />
                <div className="h-0.5 w-3/4 rounded-full bg-border/60" />
                <div className="h-0.5 w-1/2 rounded-full bg-border/40" />
              </motion.div>
              <p className="text-[11px] text-muted-foreground">{page}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Interactive Brand Kit row */}
      <motion.div
        className="bg-card rounded-xl px-4 py-3 shadow-[0_1px_2px_rgba(10,13,20,0.03),0_0_0_1px_rgba(23,23,23,0.04)] flex items-center gap-3"
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.25 }}
      >
        <div className="flex gap-1.5">
          {palettes.map((pal, i) => (
            <motion.button
              key={pal.name}
              onClick={() => setActiveColor(i)}
              className="w-6 h-6 rounded-full relative cursor-pointer"
              style={{ backgroundColor: pal.accent }}
              whileHover={{ scale: 1.15 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: "spring", stiffness: 500, damping: 20 }}
            >
              {activeColor === i && (
                <motion.div
                  className="absolute inset-[-3px] rounded-full border-2"
                  style={{ borderColor: pal.accent }}
                  layoutId="color-ring"
                  transition={{ type: "spring", stiffness: 400, damping: 25 }}
                />
              )}
            </motion.button>
          ))}
        </div>
        <span className="text-xs text-muted-foreground">
          Brand Kit · <span className="text-foreground font-medium">{p.name}</span>
        </span>
      </motion.div>
    </div>
  );
}
